import React, { FC } from 'react';
import {
  Modal,
  View,
  Text,
  TouchableOpacity,
  TouchableWithoutFeedback,
  StyleSheet,
  Dimensions,
} from 'react-native';
import { BlurView } from 'expo-blur';
import { Tooltip_t } from './common/tooltips/tooltips';

const deviceWidth = Dimensions.get('window').width;
const horizontalPadding = 20; // adjust to match your app
const modalWidth = deviceWidth - horizontalPadding * 2;

interface NotificationModalProps {
  tooltipData: Tooltip_t | null;
  visible: boolean;
  onClose: () => void;
  buttons: Array<{
    text: string;
    onPress: () => void;
  }> | null;
}

const PopupModal: FC<NotificationModalProps> = ({
  tooltipData,
  visible,
  onClose,
  buttons,
}) => {
  if (tooltipData && buttons) {
    return (
      <Modal
        transparent
        animationType="fade"
        visible={visible}
        onRequestClose={onClose}
        // statusBarTranslucent
        // presentationStyle="overFullScreen"
        // hardwareAccelerated
      >
        <TouchableWithoutFeedback onPress={onClose}>
          <View style={styles.absoluteContainer}>
            <BlurView intensity={50} tint="dark" style={styles.modalBackground}>
              <TouchableWithoutFeedback onPress={() => {}}>
                <View style={styles.modalContainer}>
                  <Text style={styles.headerText}>{tooltipData.header}</Text>
                  <View style={styles.separator} />
                  <Text style={styles.bodyText}>{tooltipData.text}</Text>

                  <View style={styles.buttonsContainer}>
                    {buttons.map((btn, idx) => (
                      <TouchableOpacity
                        key={idx}
                        style={[
                          styles.actionButton,
                          btn.text.trim().toLowerCase() === 'cancel' &&
                            styles.cancelButton,
                        ]}
                        onPress={btn.onPress}
                      >
                        <Text
                          style={[
                            styles.actionButtonText,
                            btn.text.trim().toLowerCase() === 'cancel' &&
                              styles.cancelButtonText,
                          ]}
                          numberOfLines={2}
                          allowFontScaling
                          adjustsFontSizeToFit
                        >
                          {btn.text}
                        </Text>
                      </TouchableOpacity>
                    ))}
                  </View>
                </View>
              </TouchableWithoutFeedback>
            </BlurView>
          </View>
        </TouchableWithoutFeedback>
      </Modal>
    );
  } else {
    return null;
  }
};

const styles = StyleSheet.create({
  absoluteContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  modalBackground: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    backgroundColor: '#292D33',
    width: modalWidth * 0.9, // 90% of available width
    maxWidth: 350,
    padding: 20,
    borderRadius: 10,
    alignItems: 'center',
  },
  headerText: {
    fontFamily: 'PlusJakartaSans-Bold',
    fontWeight: '700',
    fontSize: 20,
    color: '#FFFFFF',
    textAlign: 'center',
    marginBottom: 10,
  },
  separator: {
    alignSelf: 'stretch',
    borderBottomWidth: 1,
    borderStyle: 'dashed',
    borderColor: '#5F6164',
    marginVertical: 10,
  },
  bodyText: {
    fontFamily: 'PlusJakartaSans-Regular',
    fontWeight: '400',
    fontSize: 16,
    color: '#8D8E90',
    textAlign: 'center',
    marginBottom: 20,
  },

  // container to lay out an arbitrary number of buttons
  buttonsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 16,
    marginBottom: 8,
  },

  okButton: {
    backgroundColor: '#51B868',
    borderRadius: 45,
    paddingHorizontal: 16,
    height: 46,
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1, // so multiple buttons share space
    marginHorizontal: 4, // small gap between buttons
  },
  okButtonText: {
    color: '#FFFFFF',
    fontFamily: 'PlusJakartaSans-Regular',
    fontWeight: '700',
    fontSize: 16,
  },
  actionButton: {
    flexGrow: 1,
    flexShrink: 1,
    minWidth: 100,
    maxWidth: '45%', // or flexBasis: '45%'
    margin: 4,
    paddingVertical: 10,
    paddingHorizontal: 16,
    borderRadius: 25,
    backgroundColor: '#51B868',
    alignItems: 'center',
    justifyContent: 'center',
  },
  actionButtonText: {
    color: '#FFFFFF',
    fontFamily: 'PlusJakartaSans-Regular',
    fontWeight: '700',
    fontSize: 14, // slightly smaller so it fits
    textAlign: 'center',
    flexWrap: 'wrap',
  },
  cancelButton: {
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderColor: '#FFFFFF',
  },
  cancelButtonText: {
    color: '#FFFFFF',
  },
});

export default PopupModal;
